import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TreeService } from '../LayerControlPage/TreeService';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { Toast } from 'primereact/toast';

class OperationLayerType extends Component {
    toast = null;
    constructor(props) {
        super(props);
        this.toast = React.createRef();

    }

    state = {
        data: []
    }

    componentDidMount() {
        TreeService.getTreeTableColumns().then(res => {
            if (res.success) {
                this.toast.current.show({ severity: 'info', summary: 'Bilgi', detail: 'Katman Tablosu Getirildi.' });
            }
            if (res.data) {
                this.setState({ data: res.data })
            }
        })
    }

    handleRemoveButtonClick = () => {
        TreeService.deleteTreeTable().then(res => {
            if (res.success) {
                this.toast.current.show({ severity: 'info', summary: 'Bilgi', detail: 'Silme Başarılı' });
            }
        })
    }

    reject = () => {
        return;
    }


    confirm = (event) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Katman tablosu silmek üzerisiniz?',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: this.handleRemoveButtonClick,
            reject: this.reject,
            acceptLabel: "Evet",
            rejectLabel:"Hayır" 
        });
    }


    render() {
        return (
          
            <div className="card">
                <DataTable value={this.state.data} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="name" header="Kolon Adı"></Column>
                    <Column field="type" header="Kolon Tipi"></Column>
                    <Column field="insertedDate" header="Eklenme Tarihi"></Column>
                </DataTable>
                <div style={{ textAlign: 'left', marginTop: '20px' }}>
                    <Button label="Katman Tablosu Sil" severity="danger" onClick={this.confirm} />
                </div>
                <ConfirmPopup rejectLabel="Hayır" />
                <Toast ref={this.toast} />
            </div>
        )
    }

}

export default OperationLayerType;